import { StatusTags } from "../../components/common/registerUtils";
import { beautify } from "../../utils/helpers";

export const useAgents = () => {
  const tableColumns = () => [
    {
      id: "user_number",
      header: "Agent Number",
      filter: {
        type: "text",
      },
    },
    {
      id: "first_name",
      header: "First Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "last_name",
      header: "Last Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "phone_number",
      header: "Phone Number",
      filter: {
        type: "number",
      },
    },
    {
      id: "email",
      header: "Email",
      filter: {
        type: "text",
      },
    },
    {
      id: "user_status",
      header: "User Status",
      filter: {
        type: "text",
      },
    },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        user_number: item?.user_number,
        first_name: beautify(item?.first_name),
        last_name: beautify(item?.last_name),
        user_status: <StatusTags status={item?.user_status} />,
        username: item?.username,
      };
    }),
  ];
  return { tableColumns, tableData };
};
